import React, { Component, addCallback } from 'reactn'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import AdminLayout from './Components/layout/AdminLayout'
import { Login, Maintenance, Notifications, Users, Automations } from './Pages'
import Dashboard from './Pages/Dashboard'
import Background from './Components/Background'
import { restoreState } from './Services'
import { canAccessMaintenance, isMaintenanceOnlyUser } from './Global/Config'
import './App.css'
import './theme/ui.css'

export default class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loggedIn: false
    }
  }

  async componentDidMount () {
    await restoreState()
    this.setState({ loggedIn: this.global.loggedIn })

    addCallback(global => {
      if (global.loggedIn === true || global.loggedIn === false) {
        this.setState({ loggedIn: global.loggedIn })
      }
      return null
    })
  }

  renderApp () {
    const userType = this.global.user?.type
    const maintenanceOnly = isMaintenanceOnlyUser(userType)
    const maintenanceAccess = canAccessMaintenance(userType)

    if (maintenanceOnly) {
      return (
        <Router>
          <Routes>
            <Route element={<AdminLayout />}>
              <Route path='/maintenance' element={<Maintenance />} />
              <Route path='*' element={<Navigate to='/maintenance' replace />} />
            </Route>
          </Routes>
        </Router>
      )
    }

    return (
      <Router>
        <Routes>
          <Route element={<AdminLayout />}>
            <Route path='/' element={<Dashboard />} />
            <Route path='/users' element={<Users />} />
            <Route path='/notifications' element={<Notifications />} />
            <Route path='/automations' element={<Automations />} />
            <Route
              path='/maintenance'
              element={maintenanceAccess ? <Maintenance /> : <Navigate to='/' replace />}
            />
            <Route path='*' element={<Navigate to='/' replace />} />
          </Route>
        </Routes>
      </Router>
    )
  }

  postLogin () {
    this.setState({ loggedIn: true })
  }

  render () {
    const { loggedIn } = this.state
    return (
      <>
        <Toaster position='top-right' toastOptions={{ style: { borderRadius: 'var(--sf-radius-sm)', fontSize: '0.9rem' } }} />
        {loggedIn
          ? this.renderApp()
          : <Background><Login postLogin={() => this.postLogin()} /></Background>}
      </>
    )
  }
}
